import { FolderStarOutlineIcon } from './FolderStarOutlineIcon';

/**
 * author: Google
 * id 3CE11413-D500-4DFA-8913-A22A16D6DAD5
 * name folder-star-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-star-outline.svg
 * tags
 * - Files / Folders 
 */
export const FolderFavoriteOutlineIcon = FolderStarOutlineIcon;
export default FolderFavoriteOutlineIcon